module.exports = __webpack_public_path__ + "img/gafwa_logo.19f0363b.png";